import ReactNative from "react-native"
const { Linking } = ReactNative

export default {
  composeMessageWithArgs: (args, cb) => {
    Linking.openURL("sms:?body=" + encodeURIComponent(args.messageText))
  },
}
